package horcrux.common.extensions

import io.ktor.client.HttpClient
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.serialization.kotlinx.json.json
import kotlinx.serialization.json.Json

fun jsonClient(): HttpClient = HttpClient {
    this.expectSuccess = true
    install(ContentNegotiation) {
        json(Json {
            this.ignoreUnknownKeys = true
        })
    }
}
